<template>
  <!-- ========== MAIN ========== -->
  <main id="dlnkaap_formulaire_vitrine" role="main" class="bg-light">
    <!-- Breadcrumb Section -->
    <div class="bg-primary" style="background-image: url(/themes/template/img/components/abstract-shapes-20.svg);">
      <div class="container space-1 space-top-lg-2 space-bottom-lg-3">
        <div class="row align-items-center">
          <div class="d-none d-md-block">
            <h1 class="h2 text-white">Formulaire de génération de fiche projet</h1>
            <p class="h6 text-info">Ici, vous êtes porteur d'un projet qui se déroule sur un territoire, vous souhaitez le communiquer à la communauté.</p>
            <p class="h6 text-info">Offrez vous de la visibilité en ayant une page projet dans l'onglet "Ils oeuvrent".</p>
          </div>
        </div>
      </div>
    </div>
    <!-- End Breadcrumb Section -->

    <!-- Content Section -->
    <div class="container space-1 space-top-lg-0 space-bottom-lg-2 mt-lg-n10">
      <div class="row">

        <div class="col-lg-12">
          <!-- Card -->
          <div class="card mb-3 mb-lg-5">
            <div class="card-header">
              <div class="d-flex justify-content-between align-items-center">
                <h3 class="mb-0">
                  Projet
                </h3>
                <a class="btn btn-outline-primary h-100" href="javascript:;">Sauvegarder</a>
              </div>
            </div>

            <div>
              <!-- Body -->
              <div class="card-body">
                <form>
                  <p class="text-right"><i class="fa fa-arrow-down fa-2x mr-2 text-primary" aria-hidden="true"></i>
                    : Cette icone montre une réponse conditionnelle avec dépliant</p>

                  <h4 class="mb-4">Structure</h4>

                  <!-- Structure name -->
                  <div class="row form-group">
                    <label for="nom" class="col-sm-3 col-form-label input-label">
                      Nom de la structure
                    </label>
                    <div class="col-sm-9">
                      <input type="text" name="aap[nom]" id="nom" placeholder="Nom" aria-label="Nom"
                             class="form-control" v-model="nom">
                    </div>
                  </div>

                  <!-- Logo structure -->
                  <div class="row form-group"><label class="col-sm-3 col-form-label input-label">Logo de la structure</label>
                    <div class="col-sm-9">
                      <div class="media align-items-center">


                        <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                                data-toggle="tooltip" data-placement="top"
                                title="Logo de la structure">
                          <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                               id="logo_structure"
                               :src="logo_structure"
                               alt="Votre avatar"/>
                          <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                            Ajouter / modifier la photo
                            <a href="javascript:;" id="changePictureBtn" class="stretched-link" data-toggle="modal"
                               data-target="#change_logo_structure">
                              <i class="fa fa-question-circle"></i>
                            </a>
                          </figcaption>
                        </figure>

                        <dlnk-clipper
                            modal_id="change_logo_structure"
                            @imgURL="set_logo_structure($event)"
                            :crop_ratio="1">
                        </dlnk-clipper>


                      </div>
                    </div>
                  </div>

                  <hr class="my-6 mw-66 mx-auto">

                  <h4 class="mb-4">Porteur de projet</h4>

                  <!-- Nom du candidat -->
                  <div class="row form-group">
                    <label for="candidat_nom" class="col-sm-3 col-form-label input-label">
                      Nom du candidat
                    </label>
                    <div class="col-sm-9">
                      <input type="text" name="aap[candidat_nom]" id="candidat_nom"
                             placeholder="Alain Dupont" aria-label="Alain Dupont" class="form-control"
                             v-model="candidat_nom">
                    </div>
                  </div>

                  <!-- Photo du candidat -->
                  <div class="row form-group">
                    <label class="col-sm-3 col-form-label input-label">Photo du/des porteur(s)</label>
                    <div class="col-sm-9">

                      <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                              data-toggle="tooltip" data-placement="top"
                              title="Logo de la structure">
                        <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                             id="photo_porteur"
                             :src="photo_porteur"
                             alt="Votre avatar"/>
                        <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                          Ajouter / modifier la photo
                          <a href="javascript:;" class="stretched-link" data-toggle="modal"
                             data-target="#change_photo_porteur">
                            <i class="fa fa-question-circle"></i>
                          </a>
                        </figcaption>
                      </figure>

                      <dlnk-clipper
                          modal_id="change_photo_porteur"
                          @imgURL="set_photo_porteur($event)"
                          :crop_ratio="1">
                      </dlnk-clipper>

                    </div>
                  </div>

                  <!-- TODO : nouveau champ → description du porteur de projet -->
                  <div class="row form-group">
                      <label for="presPorteurLabel" class="col-sm-3 col-form-label input-label">Décrivez rapidement votre porteur</label>

                      <div class="col-sm-9">
                          <textarea rows="3" class="form-control" name="presPorteur" id="presPorteurLabel" placeholder="Une description accrocheuse ..." aria-label="Une description accrocheuse ..."></textarea>
                      </div>
                  </div>

                  <!-- Fonction du candidat -->
                  <div class="row form-group">
                    <label for="candidat_fonction"
                           class="col-sm-3 col-form-label input-label text-left">Fonction</label>
                    <div class="col-sm-9">
                      <input type="text" name="aap[candidat_fonction]" id="candidat_fonction" placeholder="Manager"
                             aria-label="Manager" class="form-control" v-model="candidat_fonction">
                    </div>
                  </div>

                  <!-- Service du candidat -->
                  <div class="row form-group">
                    <label for="candidat_service" class="col-sm-3 col-form-label input-label text-left">
                      Service (activité/rattachement)
                    </label>
                    <div class="col-sm-9">
                      <input type="text" name="aap[candidat_service]" id="candidat_service" v-model="candidat_service"
                             placeholder="Marketing" aria-label="Marketing" class="form-control">
                    </div>
                  </div>

                  <!-- Téléphone du candidat -->
                  <div class="row form-group">
                    <label for="candidat_telephone"
                           class="col-sm-3 col-form-label input-label text-left">Téléphone</label>
                    <div class="col-sm-9">
                      <input type="tel" name="aap[candidat_telephone]" id="candidat_telephone"
                             placeholder="01 23 45 67 89"
                             aria-label="01 23 45 67 89" class="form-control" v-model="candidat_telephone">
                    </div>
                  </div>

                  <!-- Email du candidat -->
                  <div class="row form-group">
                    <label for="candidat_email" class="col-sm-3 col-form-label input-label text-right">Email</label>
                    <div class="col-sm-9">
                      <input type="email" name="aap[candidat_email]" id="candidat_email" placeholder="porteur@mail.fr"
                             aria-label="porteur@mail.fr" class="form-control" v-model="candidat_email">
                    </div>
                  </div>

                  <hr class="my-6 mw-66 mx-auto">

                  <h4 class="mb-4">Le projet</h4>

                  <!-- Nom du projet -->
                  <div class="row form-group">
                    <label for="projet_nom" class="col-sm-3 col-form-label input-label text-left">Nom du projet</label>
                    <div class="col-sm-9">
                      <input type="email" name="aap[projet_nom]" id="projet_nom" placeholder="Le nom du projet"
                             aria-label="porteur@mail.fr" class="form-control" v-model="projet_nom">
                    </div>
                  </div>


                  <div class="row form-group">
                    <label for="axe" class="col-sm-3 col-form-label input-label">Axe</label>
                    <div class="col-sm-9">
                      <div class="input-group">
                        <select name="aap[axe]" id="axe" class="form-control" v-model="axe">
                          <option>Autonomie (Handicap et Senior)</option>
                          <option>Famille / Jeunesse</option>
                          <option>Insertion et action sociale</option>
                          <option>Logement et mixité sociale</option>
                          <option>Santé et petite enfance</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row form-group">
                    <label class="col-sm-3 col-form-label input-label">Thématiques</label>
                    <div class="col-sm-9 py-3">
                      <input type="hidden" name="aap[aap_tag_ids][]" value="">
                      <div class="form-check" v-for="tag in aap_tags" :key="tag.id">
                        <input type="checkbox" value="" :id="'aap_tag_' + tag.id" name="aap[aap_tag_ids][]"
                               class="form-check-input" :value="tag.id"
                               :checked="Object.values(aap_tag_ids).includes(tag.id) ">
                        <label :for="'aap_tag_' + tag.id" class="form-check-label font-size-1">
                          {{ tag.nom }}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="row form-group">
                    <label for="date_debut" class="col-sm-3 col-form-label input-label text-left">Date de début</label>
                    <div class="col-sm-9">
                      <input type="date" name="aap[date_debut]" id="date_debut" placeholder="2021-07-01"
                             aria-label="2021-07-01" class="form-control" v-model="date_debut">
                    </div>
                  </div>

<!--                /////ETAPES DU PROJET/////                   -->

<!--                  <h6 class="mt-6 mb-4">Brièvement, quelles sont les principales étapes du projet ?</h6>-->
<!--                  <div id="liste_etapes" class="col-12">-->

<!--                    <div class="mt-2"-->
<!--                         v-for="etape in aap.etapes" :key="etape.id" :id="'etapes_' + etape.id">-->
<!--                      <hr>-->
<!--                      <input type="hidden" :value="etape.id"-->
<!--                             :name="'aap[aap_etapes_projets_attributes][' + etape.id + '][id]'"-->
<!--                             :id="'etape_id_' + etape.id">-->

<!--                      <div class="row form-group ml-3">-->
<!--                        <label :for="'etape_etape_' + etape.id"-->
<!--                               class="col-sm-3 col-form-label input-label">Étape</label>-->
<!--                        <div class="col-sm-9">-->
<!--                          <input type="text" :name="'aap[aap_etapes_projets_attributes][' + etape.id + '][etape]'"-->
<!--                                 :id="'etape_etape_' + etape.id"-->
<!--                                 placeholder="Etape n°1" aria-label="Etape n°1" class="form-control" data-name="etape"-->
<!--                                 :value="etape.etape">-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="row form-group ml-3">-->
<!--                        <label :for="'etape_date_' + etape.id" class="col-sm-3 col-form-label input-label">Date</label>-->
<!--                        <div class="col-sm-9">-->
<!--                          <div class="input-group">-->
<!--                            <input type="date" :name="'aap[aap_etapes_projets_attributes][' + etape.id + '][date]'"-->
<!--                                   :id="'etape_date_' + etape.id"-->
<!--                                   class="form-control"-->
<!--                                   data-name="date" :value="etape.date">-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="row form-group ml-3 mb-0">-->
<!--                        <label :for="'etape_description_' + etape.id" class="col-sm-3 col-form-label input-label">Description</label>-->
<!--                        <div class="col-sm-9">-->
<!--                          <textarea rows="3" :name="'aap[aap_etapes_projets_attributes][' + etape.id + '][description]'"-->
<!--                                    :value="etape.description"-->
<!--                                    :id="'etape_description_' + etape.id" placeholder="Description n°1"-->
<!--                                    aria-label="Description n°1"-->
<!--                                    class="form-control" data-name="description"></textarea>-->
<!--                        </div>-->
<!--                      </div>-->

<!--                      <input value="false"-->
<!--                             type="hidden"-->
<!--                             :name="'aap[aap_etapes_projets_attributes][' + etape.id + '][_destroy]'"-->
<!--                             :id="'aap_etapes_projets_attributes_' + etape.id">-->

<!--                      <button type="button" class="btn btn-danger"-->
<!--                              @click="delete_element('aap_etapes_projets_attributes_' + etape.id, 'etapes_' + etape.id)">-->
<!--                        <i class="fas fa-times">&nbsp; Supprimer</i>-->
<!--                      </button>-->

<!--                    </div>-->

<!--                    <div id="etape_01" class="mt-2" data-attribute="aap[aap_etapes_projets_attributes]">-->
<!--                      <hr>-->

<!--                      <div class="card">-->
<!--                        <div class="card-header bg-primary text-white p-2">-->
<!--                          Nouvelle étape-->
<!--                        </div>-->
<!--                        <div class="card-body">-->
<!--                          <div class="row form-group ml-3">-->
<!--                            <label for="etape_etape_01" class="col-sm-3 col-form-label input-label">Étape</label>-->
<!--                            <div class="col-sm-9">-->
<!--                              <input type="text" name="aap[aap_etapes_projets_attributes][0][etape]" id="etape_etape_01"-->
<!--                                     placeholder="Etape" aria-label="Etape" class="form-control" data-name="etape"-->
<!--                                     v-model="new_etape_etape">-->
<!--                            </div>-->
<!--                          </div>-->
<!--                          <div class="row form-group ml-3">-->
<!--                            <label for="etape_date_01" class="col-sm-3 col-form-label input-label">Date</label>-->
<!--                            <div class="col-sm-9">-->
<!--                              <div class="input-group">-->
<!--                                <input type="date" name="aap[aap_etapes_projets_attributes][0][date]" id="etape_date_01"-->
<!--                                       class="form-control" data-name="date" v-model="new_etape_date">-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                          <div class="row form-group ml-3 mb-0">-->
<!--                            <label for="etape_description_01"-->
<!--                                   class="col-sm-3 col-form-label input-label">Description</label>-->
<!--                            <div class="col-sm-9">-->
<!--                          <textarea rows="3" name="aap[aap_etapes_projets_attributes][0][description]"-->
<!--                                    id="etape_description_01" placeholder="Description n°1" aria-label="Description n°1"-->
<!--                                    class="form-control" data-name="description"-->
<!--                                    v-model="new_etape_description"></textarea>-->
<!--                            </div>-->
<!--                          </div>-->

<!--                          <a href="javascript:" class="btn btn-primary" @click="post_structure()">-->
<!--                            <i class="fas fa-plus"></i>-->
<!--                          </a>-->

<!--                        </div>-->

<!--                      </div>-->

<!--                    </div>-->
<!--                  </div>-->



                  <h6 class="my-4">Origine du projet</h6>

                  <!-- origine -->
                  <div class="row form-group">
                    <label for="origine" class="col-sm-3 col-form-label input-label">
                      Pourquoi ce projet est-il né ?
                    </label>
                    <div class="col-sm-9">
                      <textarea rows="3" name="aap[origine]" id="origine"
                                placeholder="Une description accrocheuse ..."
                                aria-label="Une description accrocheuse ..." class="form-control"
                                v-model="origine"></textarea>
                    </div>
                  </div>

                  <!-- TODO : Illustration des ORIGINES du projet -->
                  <div class="row form-group">
                      <label class="col-sm-3 col-form-label input-label">Illustrez les origines du projet</label>
                      <div class="col-sm-9">

                        <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                                data-toggle="tooltip" data-placement="top"
                                title="Image origines">
                          <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                              id="photo_origine"
                              :src="TODO"
                              alt="Votre avatar"/>
                          <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                            Ajouter / modifier la photo
                            <a href="javascript:;" class="stretched-link" data-toggle="modal"
                              data-target="#change_photo_origines">
                              <i class="fa fa-question-circle"></i>
                            </a>
                          </figcaption>
                        </figure>

                        <dlnk-clipper
                            modal_id="change_photo_origines"
                            @imgURL="TODO"
                            :crop_ratio="1">
                        </dlnk-clipper>

                      </div>
                  </div>

                  <h6 class="my-4">Présentation du projet</h6>

                  <!--  Présentation du projet -->
                  <div class="row form-group">
                    <label for="presentation" class="col-sm-3 col-form-label input-label">
                      Comment présenteriez-vous votre projet?
                    </label>
                    <div class="col-sm-9">
                      <textarea rows="3" name="aap[presentation]" id="presentation"
                                placeholder="Une description accrocheuse ..."
                                aria-label="Une description accrocheuse ..." class="form-control"
                                v-model="presentation"></textarea>
                    </div>
                  </div>


                  <!-- Illustrez votre projet -->
                  <div class="row form-group">
                    <label class="col-sm-3 col-form-label input-label ml-3">
                      Illustrez votre projet
                    </label>

                    <div class="col-sm-9">

                      <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                              data-toggle="tooltip" data-placement="top"
                              title="Logo de la structure">
                        <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                             id="projet_illustration"
                             :src="projet_illustration"
                             alt="Votre avatar"/>
                        <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                          Ajouter / modifier la photo
                          <a href="javascript:;" class="stretched-link" data-toggle="modal"
                             data-target="#change_projet_illustration">
                            <i class="fa fa-question-circle"></i>
                          </a>
                        </figcaption>
                      </figure>

                      <dlnk-clipper
                          modal_id="change_projet_illustration"
                          @imgURL="set_projet_illustration($event)"
                          :crop_ratio="1">
                      </dlnk-clipper>
                    </div>
                  </div>


                  <h6 class="mt-4 mb-4">Détail du programme</h6>

                  <div>
                    <div :id="'etapes_' + activite.id" class="col-12" v-for="activite in aap.activites"
                         :key="activite.id">
                      <input type="hidden" :value="activite.id"
                             :name="'aap[aap_activites_projets_attributes][' + activite.id + '][id]'"
                             :id="'activite_id_' + activite.id">
                      <div class="row form-group">
                        <label :for="'activite_' + activite.id"
                               class="col-sm-3 col-form-label input-label">Activité</label>
                        <div class="col-sm-9">
                          <input type="text"
                                 :name="'aap[aap_activites_projets_attributes][' + activite.id + '][activite]'"
                                 :id="'activite_' + activite.id" aria-label="Prestation" class="form-control"
                                 :value="activite.activite">
                        </div>
                      </div>

                      <div class="row form-group mb-0">
                        <label :for="'aap_activites_description_' + activite.id"
                               class="col-sm-3 col-form-label input-label">Description</label>
                        <div class="col-sm-9">
                        <textarea rows="3"
                                  :name="'aap[aap_activites_projets_attributes][' + activite.id + '][description]'"
                                  :id="'aap_activites_description_' + activite.id" placeholder="Description"
                                  :value="activite.description"
                                  aria-label="Description n°1" class="form-control"></textarea>
                        </div>
                      </div>

                      <input value="false"
                             type="hidden"
                             :name="'aap[aap_activites_projets_attributes][' + activite.id + '][_destroy]'"
                             :id="'aap_activites_projets_attributes' + activite.id">

                      <button type="button" class="btn btn-danger"
                              @click="delete_element('aap_activites_projets_attributes' + activite.id, 'etapes_' + activite.id)">
                        <i class="fas fa-times">&nbsp; Supprimer</i>
                      </button>

                    </div>

                    <div class="card">
                      <div class="card-header bg-primary p-2 text-white">
                        Ajouter une activité
                      </div>

                      <div class="card-body">
                        <div id="activite_1" class="col-12">
                          <div class="row form-group">
                            <label for="prestationLabel" class="col-sm-3 col-form-label input-label">Activité</label>
                            <div class="col-sm-9">
                              <input type="text"
                                     name="aap[aap_activites_projets_attributes][0][activite]"
                                     id="prestationLabel" placeholder="Activité n°1" aria-label="Prestation n°1"
                                     class="form-control"
                                     v-model="new_activite_activite">
                            </div>
                          </div>

                          <div class="row form-group mb-0">
                            <label for="aap_activites_projets_attributes" class="col-sm-3 col-form-label input-label">Description</label>
                            <div class="col-sm-9">
                                  <textarea rows="3"
                                            name="aap[aap_activites_projets_attributes][0][description]"
                                            id="aap_activites_projets_attributes" placeholder="Description n°1"
                                            v-model="new_activite_description"
                                            aria-label="Description n°1" class="form-control"></textarea>
                            </div>
                          </div>

                          <!-- TODO : illustration d'une ACTIVITE -->
                          <div class="row form-group">
                            <label class="col-sm-3 col-form-label input-label">Illustrez votre activité</label>
                            <div class="col-sm-9">
                              <div class="media align-items-center">

                                <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                                        data-toggle="tooltip" data-placement="top"
                                        title="Image de l'activité">
                                  <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                                      id="image_activite_1"
                                      :src="TODO"
                                      alt="Votre avatar"/>
                                  <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                                    Ajouter / modifier la photo
                                    <a href="javascript:;" id="changeImageActBtn" class="stretched-link" data-toggle="modal"
                                      data-target="#change_image_activite">
                                      <i class="fa fa-question-circle"></i>
                                    </a>
                                  </figcaption>
                                </figure>

                                <dlnk-clipper
                                    modal_id="change_image_activite"
                                    @imgURL="TODO"
                                    :crop_ratio="1">
                                </dlnk-clipper>


                              </div>
                            </div>
                          </div>
<!--             ////// CONTENU TEMPORAIRE //////-->

                          <div class="row form-group">
                            <label for="eventPlace" class="col-sm-3 col-form-label input-label">Lieu</label>

                            <div class="col-sm-9">
                              <input id="eventPlace" type="text" class="form-control" placeholder="Saint Germain en Laye">
                            </div>
                          </div>

                          <div class="row form-group">
                            <label for="eventPrice" class="col-sm-3 col-form-label input-label">Prix</label>

                            <div class="col-sm-9 input-group">
                              <input id="eventPrice" type="text" class="form-control" placeholder="23">
                              <div class="input-group-append">
                                <span class="input-group-text" id="basic-addon2">€</span>
                              </div>
                            </div>
                          </div>

                          <div class="row form-group">
                            <label for="eventCapacity" class="col-sm-3 col-form-label input-label">Capacité</label>

                            <div class="col-sm-9">
                              <input id="eventCapacity" type="number" class="form-control" placeholder="40">
                            </div>
                          </div>

                          <div class="row form-group">
                            <label for="eventStart" class="col-sm-3 col-form-label input-label">Date de début</label>

                            <div class="col-sm-9">
                              <input id="eventStart" type="date" class="form-control" placeholder="08/08/2022">
                            </div>
                          </div>

                          <div class="row form-group">
                            <label for="eventEnd" class="col-sm-3 col-form-label input-label">Date de fin</label>

                            <div class="col-sm-9">
                              <input id="eventEnd" type="date" class="form-control" placeholder="28/08/2022">
                            </div>
                          </div>

<!--          /////   FIN CONTENU TEMPORAIRE  //////-->

                        </div>
                        <a href="javascript:" class="btn btn-primary" @click="post_structure()">
                          <i class="fas fa-plus"></i>
                        </a>
                      </div>
                    </div>
                  </div>


                  <hr class="my-6 mw-66 mx-auto">

                  <h4 id="objectifs" class="my-4" style="scroll-margin-top: 140px;">Objectifs du projet</h4>

                  <h6 class="mt-4 mb-4 ml-3">Quel est l'objectif global ?</h6>

                  <!--  projet_objectif -->
                  <div>
                    <div class="row form-group ml-3">
                      <label for="projet_objectif" class="col-sm-3 col-form-label input-label">Objectif</label>
                      <div class="col-sm-9">
                        <textarea rows="3" v-model="projet_objectif" name="aap[projet_objectif]" id="projet_objectif"
                                  placeholder="Objectif global" aria-label="Objectif global"
                                  class="form-control"></textarea>
                      </div>
                    </div>
                  </div>

                  <h6 class="mt-4 mb-4 ml-3">Quels sont les objectifs opérationnels ?</h6>

                  <div>
                    <div :id="'obj_ope_' + objectif.id" v-for="objectif in aap.objectifs" :key="objectif.id">
                      <input type="hidden" :value="objectif.id"
                             :name="'aap[aap_objectifs_projets_attributes][' + objectif.id + '][id]'"
                             :id="'objectif' + objectif.id">

                      <div class="row form-group ml-3">
                        <label :for="'objectifs_objectif' + objectif.id" class="col-sm-3 col-form-label input-label">
                          Objectif opérationnel
                        </label>
                        <div class="col-sm-9">
                          <input type="text" :value="objectif.objectif"
                                 :name="'aap[aap_objectifs_projets_attributes][' + objectif.id + '][objectif]'"
                                 :id="'objectifs_objectif' + objectif.id"
                                 placeholder="Objectif opérationnel" aria-label="Objectif opérationnel"
                                 class="form-control">
                        </div>
                      </div>
                      <div class="row form-group ml-3">
                        <label :for="'objectifs_description' + objectif.id" class="col-sm-3 col-form-label input-label">Description</label>
                        <div class="col-sm-9">
                        <textarea rows="3" :value="objectif.description"
                                  :name="'aap[aap_objectifs_projets_attributes][' + objectif.id + '][description]'"
                                  id="'objectifs_description' + objectif.id" placeholder="Description"
                                  aria-label="Description"
                                  class="form-control"></textarea>
                        </div>
                      </div>

                      <div class="row form-group ml-3">
                        <label :for="'objectifs_risque' + objectif.id"
                               class="col-sm-3 col-form-label input-label">
                          Quel est le risque que cet objectif ne soit pas atteint ?
                        </label>
                        <div class="col-sm-9">
                          <textarea rows="3"
                                    :name="'aap[aap_objectifs_projets_attributes][' + objectif.id + '][risque]'"
                                    id="'objectifs_risque' + objectif.id" placeholder="Risque"
                                    :value="objectif.risque"
                                    aria-label="Risque" class="form-control"></textarea>
                        </div>
                      </div>

                      <input value="false"
                             type="hidden"
                             :name="'aap[aap_objectifs_projets_attributes][' + objectif.id + '][_destroy]'"
                             :id="'aap_objectifs_projets_attributes' + objectif.id">

                      <button type="button" class="btn btn-danger my-2"
                              @click="delete_element('aap_objectifs_projets_attributes' + objectif.id, 'obj_ope_' + objectif.id)">
                        <i class="fas fa-times">&nbsp; Supprimer</i>
                      </button>

                    </div>


                    <div class="card">
                      <div class="card-header bg-primary text-white p-2">
                        Ajouter un objectif opérationnel
                      </div>
                      <div class="card-body">
                        <div id="objectif_operationnel">
                          <div class="row form-group ml-3">
                            <label for="objectifs_operationnel_objectif"
                                   class="col-sm-3 col-form-label input-label">Objectif opérationnel</label>
                            <div class="col-sm-9">
                              <input type="text"
                                     name="aap[aap_objectifs_projets_attributes][0][objectif]"
                                     id="objectifs_operationnel_objectif" v-model="new_objectif_objectif"
                                     placeholder="Objectif opérationnel" aria-label="Objectif opérationnel"
                                     class="form-control">
                            </div>
                          </div>
                          <div class="row form-group ml-3">
                            <label for="objectifs_operationnel_description"
                                   class="col-sm-3 col-form-label input-label">Description</label>
                            <div class="col-sm-9">
                              <textarea rows="3"
                                        name="aap[aap_objectifs_projets_attributes][0][description]"
                                        id="objectifs_operationnel_description" placeholder="Description"
                                        aria-label="Description" class="form-control"
                                        v-model="new_objectif_description"></textarea>
                            </div>
                          </div>
                          <div class="row form-group ml-3">
                            <label for="aap_objectifs_projets_attributes_risque"
                                   class="col-sm-3 col-form-label input-label">
                              Quel est le risque que cet objectif ne soit pas atteint ?
                            </label>
                            <div class="col-sm-9">
                              <textarea rows="3"
                                        name="aap[aap_objectifs_projets_attributes][0][risque]"
                                        id="aap_objectifs_projets_attributes_risque" placeholder="Risque n°1"
                                        data-name="risque" v-model="new_objectif_risque"
                                        aria-label="Risque n°1" class="form-control"></textarea>
                            </div>
                          </div>

                          <!-- TODO : illustration d'un OBJECTIF -->
                          <div class="row form-group"><label class="col-sm-3 col-form-label input-label ml-3">Illustrez votre objectif</label>
                            <div class="col-sm-9">
                              <div class="media align-items-center">

                                <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                                        data-toggle="tooltip" data-placement="top"
                                        title="Image de l'objectif">
                                  <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                                      id="image_objectif_1"
                                      :src="TODO"
                                      alt="Votre avatar"/>
                                  <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                                    Ajouter / modifier la photo
                                    <a href="javascript:;" id="changePictureObjBtn" class="stretched-link" data-toggle="modal"
                                      data-target="#change_image_objectif">
                                      <i class="fa fa-question-circle"></i>
                                    </a>
                                  </figcaption>
                                </figure>

                                <dlnk-clipper
                                    modal_id="change_image_objectif"
                                    @imgURL="TODO"
                                    :crop_ratio="1">
                                </dlnk-clipper>


                              </div>
                            </div>
                          </div>


                        </div>

                        <a href="javascript:" class="btn btn-primary" @click="post_structure()">
                          <i class="fas fa-plus"></i>
                        </a>
                      </div>
                    </div>
                  </div>

                  <hr class="my-6 mw-66 mx-auto">

                  <h4 class="my-4">Demande de participation</h4>

                  <div class="row form-group">
                    <label class="col-sm-3 col-form-label input-label">
                      Avez-vous besoin de bénévoles ?
                      <i aria-hidden="true" class="fa fa-arrow-down ml-2 text-primary"></i>
                    </label>

                    <div class="col-sm-9 my-auto">
                      <div class="form-check form-check-inline">
                        <input type="radio" name="aap[benevoles]" id="benevoles_oui"
                               @change="toggleCollapse('#tiroir4')"
                               class="form-check-input" value="1" :checked="besoins_benevoles === true">
                        <label for="benevoles_oui" class="form-check-label">Oui</label>
                      </div>

                      <div class="form-check form-check-inline">
                        <input type="radio" name="aap[benevoles]" id="benevoles_non"
                               @change="toggleCollapse('#tiroir4', false)"
                               class="form-check-input" value="0" :checked="besoins_benevoles != true">
                        <label for="benevoles_non" class="form-check-label">Non</label>
                      </div>
                    </div>
                  </div>

                  <div id="tiroir4" class="collapse mb-4" v-bind:class="{ show: besoins_benevoles }">
                    <h6 class="mt-4 mb-4 ml-3">
                      Détaillez les missions à destination des bénévoles</h6>

                    <div>
                      <div v-for="benevole in aap.benevoles_projet" :key="benevole.id"
                           class="card card-body card-bordered"
                           :id="'benevole_' + benevole.id">
                        <hr>
                        <input type="hidden" :name="'aap[aap_benevoles_attributes][' + benevole.id + '][id]'"
                               :id="'poste_id_' + benevole.id" :value="benevole.id">
                        <div class="row form-group ml-3">
                          <label for="'benevole_mission_' + benevole.id" class="col-sm-3 col-form-label input-label">
                            Détail mission
                          </label>
                          <div class="col-sm-9">
                            <textarea rows="3" :id="'benevole_mission_' + benevole.id" :value="benevole.mission"
                                      :name="'aap[aap_benevoles_attributes][' + benevole.id + '][mission]'"
                                      placeholder="Description" aria-label="Description"
                                      class="form-control"></textarea>
                          </div>
                        </div>
                        <div class="row form-group ml-3">
                          <label for="benevole_nombre" class="col-sm-3 col-form-label input-label">
                            Nombre de bénévoles pour la mission</label>
                          <div class="col-sm-9">
                            <input type="number" :id="'benevole_nombre_' + benevole.id" :value="benevole.nombre"
                                   placeholder="5" aria-label="5" class="form-control" min="0" step="1"
                                   :name="'aap[aap_benevoles_attributes][' + benevole.id + '][nombre]'">
                          </div>
                        </div>

                        <input value="false"
                               type="hidden"
                               :name="'aap[aap_benevoles_attributes][' + benevole.id + '][_destroy]'"
                               :id="'aap_benevoles_attributes_' + benevole.id">

                        <button type="button" class="btn btn-danger"
                                @click="delete_element('aap_benevoles_attributes_' + benevole.id, 'benevole_' + benevole.id)">
                          <i class="fas fa-times">&nbsp; Supprimer</i>
                        </button>


                      </div>

                      <div class="card">
                        <div class="card-header bg-primary text-white p-2">
                          Ajouter une mission
                        </div>
                        <div class="card-body">
                          <div class="card card-body card-bordered" id="benevole"
                               data-attribute="aap[aap_benevoles_attributes]">
                            <div class="row form-group ml-3">
                              <label for="benevole_mission" class="col-sm-3 col-form-label input-label">
                                Détail mission
                              </label>
                              <div class="col-sm-9">
                            <textarea rows="3" id="benevole_mission" data-name="mission"
                                      name="aap[aap_benevoles_attributes][0][mission]" v-model="new_benevole_mission"
                                      placeholder="Description n°1" aria-label="Description n°1"
                                      class="form-control"></textarea>
                              </div>
                            </div>
                            <div class="row form-group ml-3">
                              <label for="benevole_nombre" class="col-sm-3 col-form-label input-label">
                                Nombre de bénévoles pour la mission</label>
                              <div class="col-sm-9">
                                <input type="number" id="benevole_nombre" data-name="nombre" min="0" step="1"
                                       placeholder="5" aria-label="5" class="form-control" v-model="new_benevole_nombre"
                                       name="aap[aap_benevoles_attributes][0][nombre]">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <a href="javascript:" class="btn btn-primary" @click="post_structure()">
                      <i class="fas fa-plus"></i>
                    </a>
                  </div>


                  <div class="row form-group">
                    <label class="col-sm-3 col-form-label input-label">
                      Avez-vous besoin de matériel ?
                      <i aria-hidden="true" class="fa fa-arrow-down ml-2 text-primary"></i>
                    </label>
                    <div class="col-sm-9 my-auto">
                      <div class="form-check form-check-inline">
                        <input type="radio" name="aap[besoins_materiels]" id="besoins_materiels_oui"
                               @change="toggleCollapse('#tiroir5')" value="1"
                               class="form-check-input" :checked="besoins_materiels === true">
                        <label
                            for="besoins_materiels_oui" class="form-check-label">
                          Oui
                        </label></div>
                      <div class="form-check form-check-inline">
                        <input type="radio" name="aap[besoins_materiels]" id="besoins_materiels_non" value="0"
                               @change="toggleCollapse('#tiroir5', false)"
                               class="form-check-input" :checked="besoins_materiels != true">
                        <label
                            for="besoins_materiels_non" class="form-check-label">
                          Non
                        </label>
                      </div>
                    </div>
                  </div>

                  <div id="tiroir5" class="collapse mb-4" v-bind:class="{ show: besoins_materiels }">
                    <h6 class="mt-4 mb-4 ml-3">Détaillez votre besoin</h6>
                    <div class="card card-body card-bordered">
                      <div class="row form-group ml-3">
                        <label for="materiels" class="col-sm-3 col-form-label input-label">Explications</label>
                        <div class="col-sm-9">
                          <textarea rows="3" name="aap[materiels]" id="materiels" v-model="materiels"
                                    placeholder="Description n°1" aria-label="Description n°1"
                                    class="form-control"></textarea></div>
                      </div>
                    </div>
                  </div>

                  <div class="row form-group">
                    <label class="col-sm-3 col-form-label input-label">
                      Avez-vous besoin de locaux ?<i aria-hidden="true" class="fa fa-arrow-down ml-2 text-primary"></i>
                    </label>
                    <div class="col-sm-9 my-auto">
                      <div class="form-check form-check-inline">
                        <input type="radio" name="aap[besoins_locaux]" id="besoins_locaux_oui"
                               @change="toggleCollapse('#tiroir7')"
                               class="form-check-input" value="1" :checked="besoins_locaux === true">
                        <label for="besoins_locaux_oui" class="form-check-label">Oui</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input type="radio" name="aap[besoins_locaux]" id="besoins_locaux_non"
                               @change="toggleCollapse('#tiroir7', false)"
                               class="form-check-input" value="0" :checked="besoins_locaux != true">
                        <label for="besoins_locaux_non" class="form-check-label">Non</label>
                      </div>
                    </div>
                  </div>

                  <div id="tiroir7" class="collapse mb-4" v-bind:class="{ show: besoins_locaux }">
                    <h6 class="mt-4 mb-4 ml-3">Détaillez votre besoin</h6>
                    <div class="card card-body card-bordered">
                      <div class="row form-group ml-3">
                        <label for="locaux" class="col-sm-3 col-form-label input-label">Explications</label>
                        <div class="col-sm-9">
                          <textarea rows="3" name="aap[locaux]" id="locaux" placeholder="Description n°1"
                                    v-model="locaux"
                                    aria-label="Description n°1" class="form-control"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- TODO : la demande d'expertise n'existe pas encore dans la BDD-->
                  <div class="row form-group">
                    <label class="col-sm-3 col-form-label input-label">
                      Avez-vous besoin d'une expertise dans un domaine ?<i aria-hidden="true" class="fa fa-arrow-down ml-2 text-primary"></i>
                    </label>
                    <div class="col-sm-9 my-auto">
                      <div class="form-check form-check-inline">
                        <input type="radio" name="besoins_expertise" id="besoins_expertise_oui"
                               @change="toggleCollapse('#tiroir8')"
                               class="form-check-input" value="1" :checked="besoins_expertise === true">
                        <label for="besoins_expertise_oui" class="form-check-label">Oui</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input type="radio" name="besoins_expertise" id="besoins_expertise_non"
                               @change="toggleCollapse('#tiroir8', false);"
                               class="form-check-input" value="0" :checked="besoins_expertise != true">
                        <label for="besoins_expertise_non" class="form-check-label">Non</label>
                      </div>
                    </div>
                  </div>

                  <div id="tiroir8" class="collapse mb-4" v-bind:class="{ show: besoins_expertise }">
                    <h6 class="mt-4 mb-4 ml-3">Détaillez votre besoin</h6>
                    <div class="card card-body card-bordered">
                      <div class="row form-group ml-3">
                        <label for="expertise" class="col-sm-3 col-form-label input-label">Explications</label>
                        <div class="col-sm-9">
                          <textarea rows="2" name="" id="expertise" placeholder="Description n°1"
                                    v-model="expertise"
                                    aria-label="Description n°1" class="form-control"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!--                  <div class="row form-group">-->
                  <!--                    <label class="col-sm-3 col-form-label input-label">-->
                  <!--                      Avez-vous besoin d'un financement extérieur ?<i aria-hidden="true" class="fa fa-arrow-down ml-2 text-primary"></i>-->
                  <!--                    </label>-->
                  <!--                    <div class="col-sm-9 my-auto">-->
                  <!--                      <div class="form-check form-check-inline">-->
                  <!--                        <input type="radio" name="besoins_financement" id="besoins_financement_oui"-->
                  <!--                               @change="toggleCollapse('#tiroir9')"-->
                  <!--                               class="form-check-input" value="1" :checked="besoins_financement === true">-->
                  <!--                        <label for="besoins_financement_oui" class="form-check-label">Oui</label>-->
                  <!--                      </div>-->
                  <!--                      <div class="form-check form-check-inline">-->
                  <!--                        <input type="radio" name="besoins_financement" id="besoins_financement_non"-->
                  <!--                               @change="toggleCollapse('#tiroir9', false);"-->
                  <!--                               class="form-check-input" value="0" :checked="besoins_financement != true">-->
                  <!--                        <label for="besoins_financement_non" class="form-check-label">Non</label>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                  </div>-->

                  <!--                  <div id="tiroir9" class="collapse mb-4" v-bind:class="{ show: besoins_financement }"><h6-->
                  <!--                      class="mt-4 mb-4 ml-3">Détaillez votre besoin</h6>-->
                  <!--                    <div class="card card-body card-bordered">-->
                  <!--                      <div class="row form-group ml-3">-->
                  <!--                        <label for="montant_exterieur" class="col-sm-3 col-form-label input-label">Montant demandé</label>-->
                  <!--                        <div class="col-sm-9">-->
                  <!--                          <div class="input-group">-->
                  <!--                            <input type="number" class="form-control" id="montant_exterieur" placeholder="1234" aria-describedby="basic-addon2"-->
                  <!--                                   v-model="demande_financement_montant">-->
                  <!--                            <div class="input-group-append">-->
                  <!--                              <span class="input-group-text" id="basic-addon2">€</span>-->
                  <!--                            </div>-->
                  <!--                          </div>-->
                  <!--                        </div>-->
                  <!--                      </div>-->
                  <!--                      <div class="row form-group ml-3">-->
                  <!--                        <label for="financement" class="col-sm-3 col-form-label input-label">Explications</label>-->
                  <!--                        <div class="col-sm-9">-->
                  <!--                          <textarea rows="2" name="" id="financement" placeholder="Description n°1"-->
                  <!--                                    v-model="demande_financement"-->
                  <!--                                    aria-label="Description n°1" class="form-control"></textarea>-->
                  <!--                        </div>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                  </div>-->


                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  props: ['aap_id'],
  data: function () {
    return {
      message: "",
      message_type: "",

      customer: Object,
      aap: Object,
      aap_communes: Array,
      aap_tags: Array,
      aap_quartiers: Array,
      aap_publics: Array,

      new_etape_date: Date,
      new_etape_description: String,
      new_etape_etape: String,
      new_activite_description: String,
      new_activite_activite: String,
      new_intervenant_nombre: Number,
      new_intervenant_fonction: String,
      new_objectif_objectif: String,
      new_objectif_description: String,
      new_objectif_risque: String,
      new_poste_montant: Number,
      new_poste_nom: Number,
      new_benevole_nombre: Number,
      new_benevole_mission: String,
      new_co_financement_nom: String,
      new_co_financement_montant: Number,
      new_financement_attente_nom: String,
      new_financement_attente_montant: Number,
      new_financement_attente_date: Date,
      new_coporteur_nom: String,
      new_coporteur_co_finance: Number,

      new_indicateur: String,
      new_indicateur_indicateur: String,
      new_indicateur_resultat: String,
      new_indicateur_resultat_indicateur: String,

      invalid_siret: Boolean,
      invalid_code_postal: Boolean,
      invalid_ville: Boolean,
      invalid_adresse: Boolean,
      invalid_date_immatriculation: Boolean,
      invalid_telephone: Boolean,
      invalid_email: Boolean,
      invalid_site_web: Boolean,
      invalid_statut_juridique: Boolean,
      invalid_asso_president: Boolean,
      invalid_asso_adresse: Boolean,
      invalid_asso_code_postal: Boolean,
      invalid_asso_ville: Boolean,
      invalid_asso_utiliste_public: Boolean,
      invalid_activite_principale: Boolean,
      invalid_contact_email: Boolean,
      invalid_taille_structure: Boolean,
      invalid_taille_salarie: Boolean,
      invalid_candidat_nom: Boolean,
      invalid_candidat_telephone: Boolean,
      invalid_candidat_fonction: Boolean,
      invalid_candidat_service: Boolean,
      invalid_candidat_email: Boolean,
      invalid_candidat_projet_deux_annees_precedentes_coporte_detail: Boolean,
      invalid_axe: Boolean,
      invalid_date_debut: Boolean,
      invalid_date_fin: Boolean,
      invalid_origine: Boolean,
      invalid_presentation: Boolean,
      invalid_evenements_ponctuel: Boolean,
      invalid_activites_annuelles: Boolean,
      invalid_ateliers_activite: Boolean,
      invalid_nombre_cdi: Boolean,
      invalid_nombre_cdi_etp: Boolean,
      invalid_nombre_cdd: Boolean,
      invalid_nombre_cdd_etp: Boolean,
      invalid_nombre_precaire: Boolean,
      invalid_nombre_precaire_etp: Boolean,
      invalid_nombre_contrat_aides: Boolean,
      invalid_nombre_contrat_aides_etp: Boolean,
      invalid_nombre_benevoles: Boolean,
      invalid_nombre_benevoles_etp: Boolean,
      invalid_nombre_fonctionnaires: Boolean,
      invalid_nombre_fonctionnaires_etp: Boolean,
      invalid_projet_objectif: Boolean,
      invalid_indicateurs: Boolean,
      invalid_unites_mesure: Boolean,
      invalid_impact_social: Boolean,
      invalid_femmes_tranche_1: Boolean,
      invalid_hommes_tranche_1: Boolean,
      invalid_femmes_tranche_2: Boolean,
      invalid_hommes_tranche_2: Boolean,
      invalid_femmes_tranche_3: Boolean,
      invalid_hommes_tranche_3: Boolean,
      invalid_femmes_tranche_4: Boolean,
      invalid_hommes_tranche_4: Boolean,
      invalid_femmes_tranche_5: Boolean,
      invalid_hommes_tranche_5: Boolean,
      invalid_femmes_tranche_6: Boolean,
      invalid_hommes_tranche_6: Boolean,
      invalid_subvention_solicitee: Boolean,
      invalid_budget_global: Boolean,


      logo_structure: String,
      photo_porteur: String,
      projet_illustration: String,
      nom: String,
      code_postal: String,
      ville: String,
      adresse: String,
      date_immatriculation: String,
      telephone: String,
      email: String,
      site_web: String,
      statut_juridique: String,
      asso_president: String,
      asso_adresse: String,
      asso_code_postal: String,
      asso_ville: String,
      asso_utilite_public: Boolean,
      activite_principale: String,
      contact_email: String,
      salaries: Boolean,
      status: String,
      taille_structure: String,
      candidat_nom: String,
      candidat_telephone: String,
      candidat_fonction: String,
      candidat_service: String,
      candidat_email: String,
      actions_recentes: Boolean,
      actions_recentes_description: String,
      financeur_recent: String,
      coporte_recent: Boolean,
      coporte_recent_description: String,
      axe: String,
      projet_nom: String,
      date_debut: Date,
      date_fin: Date,
      origine: String,
      presentation: String,
      evenements_ponctuel: Number,
      activites_annuelles: Number,
      ateliers_activite: Number,
      nombre_cdi_etp: Number,
      nombre_cdi: Number,
      nombre_cdd: Number,
      nombre_cdd_etp: Number,
      nombre_precaire: Number,
      nombre_precaire_etp: Number,
      nombre_contrat_aides: Number,
      nombre_contrat_aides_etp: Number,
      nombre_benevoles: Number,
      nombre_benevoles_etp: Number,
      nombre_fonctionnaires: Number,
      nombre_fonctionnaires_etp: Number,
      nombre_autres: Number,
      nombre_autres_etp: Number,
      projet_objectif: String,
      indicateurs: Array,
      unites_mesure: String,
      aap_tag_ids: Array,
      aap_quartier_ids: Array,
      aap_public_ids: Array,
      aap_commune_ids: Array,
      impact_social: String,
      femmes_tranche_1: Number,
      hommes_tranche_1: Number,
      femmes_tranche_2: Number,
      hommes_tranche_2: Number,
      femmes_tranche_3: Number,
      hommes_tranche_3: Number,
      femmes_tranche_4: Number,
      hommes_tranche_4: Number,
      femmes_tranche_5: Number,
      hommes_tranche_5: Number,
      femmes_tranche_6: Number,
      hommes_tranche_6: Number,

      // Budget
      budget_global: Number,
      subvention_sollicitee: Number,
      max_subvention: Number,
      charges: Number,
      autre_financement: Number,
      cofinancements: Boolean,
      cofinancements_attentes: Boolean,

      // Informations complémentaires
      infos_complementaires: String,
      besoins_benevoles: Boolean,
      besoins_materiels: Boolean,
      besoins_locaux: Boolean,
      besoins_expertise: Boolean,
      besoins_financement: Boolean,
      benevoles: String,
      locaux: String,
      materiels: String,
      coporteur: Boolean,
      expertise: String,
      demande_financement: String,
      demande_financement_montant: Number,


      is_association: Boolean,
    }
  },

  created() {

  },

  destroyed() {

  },

  mounted() {

    this.id_aap = this.aap_id
    this.is_association = false

    this.step = 'structure'
    this.invalid_siret = false
    this.invalid_code_postal = false
    this.invalid_ville = false
    this.invalid_adresse = false
    this.invalid_date_immatriculation = false
    this.invalid_telephone = false
    this.invalid_email = false
    this.invalid_site_web = false
    this.invalid_statut_juridique = false
    this.invalid_asso_president = false
    this.invalid_asso_adresse = false
    this.invalid_asso_code_postal = false
    this.invalid_asso_ville = false
    this.invalid_asso_utiliste_public = false
    this.invalid_activite_principale = false
    this.invalid_contact_email = false
    this.invalid_taille_structure = false
    this.invalid_salaries = false
    this.invalid_status = false
    this.invalid_candidat_nom = false
    this.invalid_candidat_telephone = false
    this.invalid_candidat_fonction = false
    this.invalid_candidat_service = false
    this.invalid_candidat_email = false
    this.actions_recentes_description = false
    this.invalid_axe = false
    this.invalid_date_debut = false
    this.invalid_date_fin = false
    this.invalid_origine = false
    this.invalid_presentation = false
    this.invalid_evenements_ponctuel = false
    this.invalid_activites_annuelles = false
    this.invalid_ateliers_activite = false
    this.invalid_nombre_cdi = false
    this.invalid_nombre_cdi_etp = false
    this.invalid_nombre_cdd = false
    this.invalid_nombre_cdd_etp = false
    this.invalid_nombre_precaire = false
    this.invalid_nombre_precaire_etp = false
    this.invalid_nombre_contrat_aides = false
    this.invalid_nombre_contrat_aides_etp = false
    this.invalid_nombre_benevoles = false
    this.invalid_nombre_benevoles_etp = false
    this.invalid_nombre_fonctionnaires = false
    this.invalid_nombre_fonctionnaires_etp = false
    this.invalid_nombre_autres = false
    this.invalid_nombre_autres_etp = false
    this.invalid_projet_objectif = false
    this.invalid_indicateurs = false
    this.invalid_unites_mesure = false
    this.invalid_impact_social = false
    this.invalid_femmes_tranche_1 = false
    this.invalid_hommes_tranche_1 = false
    this.invalid_femmes_tranche_2 = false
    this.invalid_hommes_tranche_2 = false
    this.invalid_femmes_tranche_3 = false
    this.invalid_hommes_tranche_3 = false
    this.invalid_femmes_tranche_4 = false
    this.invalid_hommes_tranche_4 = false
    this.invalid_femmes_tranche_5 = false
    this.invalid_hommes_tranche_5 = false
    this.invalid_femmes_tranche_6 = false
    this.invalid_hommes_tranche_6 = false
    this.invalid_subvention_solicitee = true
    this.invalid_budget_global = true


    this.logo_structure = "/modules/dlnkaap/img/socialmedia.jpg"
    this.photo_porteur = "/modules/dlnkaap/img/socialmedia.jpg"
    this.projet_illustration = "/modules/dlnkaap/img/socialmedia.jpg"
    this.siret = ""
    this.nom = ""
    this.code_postal = ""
    this.adresse = ""
    this.ville = ""
    this.telephone = ""
    this.email = ""
    this.site_web = ""
    this.statut_juridique = ""
    this.asso_president = ""
    this.asso_adresse = ""
    this.asso_code_postal = ""
    this.asso_ville = ""
    this.asso_utilite_public = ""
    this.activite_principale = ""
    this.contact_email = ""
    this.taille_structure = ""
    this.salaries = false
    this.status = ""
    this.candidat_nom = ""
    this.candidat_telephone = ""
    this.candidat_fonction = ""
    this.candidat_service = ""
    this.candidat_email = ""
    this.coporte_recent = false
    this.coporte_recent_description = ""
    this.actions_recentes = false
    this.actions_recentes_description = ""
    this.financeur_recent = ""
    this.axe = ""
    this.projet_nom = ""
    this.origine = ""
    this.presentation = ""
    this.evenements_ponctuel = 0
    this.activites_annuelles = 0
    this.ateliers_activite = 0
    this.nombre_cdi = 0
    this.nombre_cdi_etp = 0
    this.nombre_cdd = 0
    this.nombre_cdd_etp = 0
    this.nombre_precaire = 0
    this.nombre_precaire_etp = 0
    this.nombre_contrat_aides = 0
    this.nombre_contrat_aides_etp = 0
    this.nombre_benevoles = 0
    this.nombre_benevoles_etp = 0
    this.nombre_fonctionnaires = 0
    this.nombre_fonctionnaires_etp = 0
    this.nombre_autres = 0
    this.nombre_autres_etp = 0
    this.projet_objectif = ""
    this.indicateurs = ""
    this.aap_tag_ids = []
    this.aap_quartier_ids = []
    this.aap_public_ids = []
    this.aap_commune_ids = []
    this.unites_mesure = ""
    this.impact_social = ""
    this.femmes_tranche_1 = 0
    this.hommes_tranche_1 = 0
    this.femmes_tranche_2 = 0
    this.hommes_tranche_2 = 0
    this.femmes_tranche_3 = 0
    this.hommes_tranche_3 = 0
    this.femmes_tranche_4 = 0
    this.hommes_tranche_4 = 0
    this.femmes_tranche_5 = 0
    this.hommes_tranche_5 = 0
    this.femmes_tranche_6 = 0
    this.hommes_tranche_6 = 0

    // Budget
    this.budget_global = 0
    this.charges = 0
    this.autre_financement = 0
    this.max_subvention = 0
    this.subvention_sollicitee = 0
    this.cofinancements = 0
    this.cofinancements_attente = false


    this.infos_complementaires = ""
    this.besoins_materiels = false
    this.besoins_locaux = false
    this.besoins_benevoles = false
    this.besoins_expertise = false
    this.besoins_financement = false
    this.locaux = ""
    this.materiels = ""
    this.benevoles = ""
    this.expertise = ""
    this.demande_financement = ""
    this.demande_financement_montant = 0

    this.coporteur = false
    this.coporteur_nom = ""
    this.coporteur_site_internet = ""
    this.coporteur_co_finance = 0
    this.cofinancements = false

    this.get_data()
  },

  computed: {

    public_total: function () {

      if (isNaN(parseInt(this.femmes_tranche_1, 10)))  this.femmes_tranche_1 = 0
      if (isNaN(parseInt(this.femmes_tranche_2, 10)))  this.femmes_tranche_2 = 0
      if (isNaN(parseInt(this.femmes_tranche_3, 10)))  this.femmes_tranche_3 = 0
      if (isNaN(parseInt(this.femmes_tranche_4, 10)))  this.femmes_tranche_4 = 0
      if (isNaN(parseInt(this.femmes_tranche_5, 10)))  this.femmes_tranche_5 = 0
      if (isNaN(parseInt(this.femmes_tranche_6, 10)))  this.femmes_tranche_6 = 0

      if (isNaN(parseInt(this.hommes_tranche_1, 10)))  this.hommes_tranche_1 = 0
      if (isNaN(parseInt(this.hommes_tranche_2, 10)))  this.hommes_tranche_2 = 0
      if (isNaN(parseInt(this.hommes_tranche_3, 10)))  this.hommes_tranche_3 = 0
      if (isNaN(parseInt(this.hommes_tranche_4, 10)))  this.hommes_tranche_4 = 0
      if (isNaN(parseInt(this.hommes_tranche_5, 10)))  this.hommes_tranche_5 = 0
      if (isNaN(parseInt(this.hommes_tranche_6, 10)))  this.hommes_tranche_6 = 0


      return parseInt(this.femmes_tranche_1, 10) + parseInt(this.femmes_tranche_2, 10) + parseInt(this.femmes_tranche_3, 10)
          + parseInt(this.femmes_tranche_4, 10) + parseInt(this.femmes_tranche_5, 10) + parseInt(this.femmes_tranche_6, 10)
          + parseInt(this.hommes_tranche_1, 10) + parseInt(this.hommes_tranche_2, 10) + parseInt(this.hommes_tranche_3, 10)
          + parseInt(this.hommes_tranche_4, 10) + parseInt(this.hommes_tranche_5, 10) + parseInt(this.hommes_tranche_6, 10)

    },

    total_personne: function () {

      if (isNaN(parseInt(this.nombre_cdi, 10)))             this.nombre_cdi = 0
      if (isNaN(parseInt(this.nombre_cdd, 10)))             this.nombre_cdd = 0
      if (isNaN(parseInt(this.nombre_precaire, 10)))        this.nombre_precaire = 0
      if (isNaN(parseInt(this.nombre_contrat_aides, 10)))   this.nombre_contrat_aides = 0
      if (isNaN(parseInt(this.nombre_benevoles, 10)))       this.nombre_benevoles = 0
      if (isNaN(parseInt(this.nombre_fonctionnaires, 10)))  this.nombre_fonctionnaires = 0
      if (isNaN(parseInt(this.nombre_autres, 10)))          this.nombre_autres = 0


      return parseInt(this.nombre_cdi, 10) + parseInt(this.nombre_cdd, 10) + parseInt(this.nombre_precaire, 10)
          + parseInt(this.nombre_contrat_aides, 10) + parseInt(this.nombre_benevoles, 10) + parseInt(this.nombre_fonctionnaires, 10)
          + parseInt(this.nombre_autres, 10)
    },

    total_etp: function () {

      if (isNaN(parseInt(this.nombre_cdi_etp, 10)))             this.nombre_cdi_etp = 0
      if (isNaN(parseInt(this.nombre_cdd_etp, 10)))             this.nombre_cdd_etp = 0
      if (isNaN(parseInt(this.nombre_precaire_etp, 10)))        this.nombre_precaire_etp = 0
      if (isNaN(parseInt(this.nombre_contrat_aides_etp, 10)))   this.nombre_contrat_aides_etp = 0
      if (isNaN(parseInt(this.nombre_benevoles_etp, 10)))       this.nombre_benevoles_etp = 0
      if (isNaN(parseInt(this.nombre_fonctionnaires_etp, 10)))  this.nombre_fonctionnaires_etp = 0
      if (isNaN(parseInt(this.nombre_autres_etp, 10)))          this.nombre_autres_etp = 0


      let total =  parseFloat(this.nombre_cdi_etp) + parseFloat(this.nombre_cdd_etp) + parseFloat(this.nombre_precaire_etp)
          + parseFloat(this.nombre_contrat_aides_etp) + parseFloat(this.nombre_benevoles_etp)
          + parseFloat(this.nombre_fonctionnaires_etp) + parseFloat(this.nombre_autres_etp)

      return total.toFixed(1)
    }

  },

  watch: {
    statut_juridique: function (new_val) {
      const _this = this;
      if (new_val === 'Association') {
        _this.is_association = true
        $('#asso_details').collapse('show');
      } else {
        _this.is_association = false
        $('#asso_details').collapse('hide');
      }
    },
  },

  methods: {

    close_message: function () {
      this.message = null;
    },

    delete_element: function (control_target, div_target) {
      document.getElementById(div_target).style.display = "none";
      document.getElementById(control_target).value = "true";
    },

    get_data: async function () {
      const _this = this;

      _this.new_etape_date = ""
      _this.new_etape_indicateur = ""
      _this.new_etape_description = ""
      _this.new_etape_etape = ""
      _this.new_indicateur_indicateur = ""
      _this.new_indicateur_resultat_indicateur = ""
      _this.new_activite_description = ""
      _this.new_activite_activite = ""
      _this.new_intervenant_nombre = null
      _this.new_intervenant_fonction = ""
      _this.new_objectif_objectif = ""
      _this.new_objectif_description = ""
      _this.new_objectif_risque = ""
      _this.new_poste_montant = null
      _this.new_poste_nom = ""
      _this.new_benevole_nombre = null
      _this.new_benevole_mission = ""
      _this.new_co_financement_nom = ""
      _this.new_co_financement_montant = null

      _this.new_financement_attente_nom = ""
      _this.new_financement_attente_date = ""
      _this.new_financement_attente_montant = null

      _this.new_coporteur_nom = ""
      _this.new_coporteur_co_finance = null

      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aap_tags.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      _this.telephone = customer.mobile_phone
      _this.email = customer.email
      _this.asso_president = `${customer.firstname} ${customer.lastname}`
      _this.candidat_nom = `${customer.firstname} ${customer.lastname}`
      _this.candidat_telephone = customer.mobile_phone
      _this.candidat_email = customer.email

      axios.get(api_url)
          .then(function (response) {
            _this.aap_tags = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );

      [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aap_quartiers.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.aap_quartiers = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );

      [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "aap_communes.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.aap_communes = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );


      if (_this.aap_id > 0) {
        [secure_key, customer_id, api_url] = await get_token_2()
        const api_base_url = api_url
        api_url += `aaps/${_this.aap_id}.json`
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios.get(api_url)
            .then(function (response) {
              _this.aap = response.data.aap
              const aap = _this.aap

              // ******************* STRUCTURE *******************
              //
              _this.siret = aap.siret
              _this.date_immatriculation = aap.date_immatriculation
              _this.nom = aap.nom
              _this.telephone = aap.telephone
              _this.email = aap.email
              _this.ville = aap.ville
              _this.code_postal = aap.code_postal
              _this.adresse = aap.adresse
              _this.site_web = aap.site_web
              _this.statut_juridique = aap.statut_juridique
              _this.asso_president = aap.asso_president
              _this.asso_adresse = aap.asso_adresse
              _this.asso_ville = aap.asso_ville
              _this.asso_code_postal = aap.asso_code_postal
              _this.asso_utilite_public = aap.asso_utilite_public
              _this.taille_structure = aap.taille_structure
              _this.contact_email = aap.contact_email
              _this.activite_principale = aap.activite_principale
              _this.salaries = aap.salaries
              _this.status = aap.status

              if (typeof(aap.logo_structure) != 'undefined' ) {
                _this.logo_structure = aap.logo_structure
              }


              // ******************* PROJET *******************
              //
              _this.candidat_nom = aap.candidat_nom
              if (typeof(aap.photo_porteur) != 'undefined' ) {
                _this.photo_porteur = aap.photo_porteur
              }

              _this.candidat_fonction = aap.candidat_fonction
              _this.candidat_service = aap.candidat_service
              _this.candidat_telephone = aap.candidat_telephone
              _this.candidat_email = aap.candidat_email
              _this.actions_recentes = aap.actions_recentes
              _this.actions_recentes_description = aap.actions_recentes_description
              _this.financeur_recent = aap.financeur_recent
              _this.coporte_recent = aap.coporte_recent
              _this.coporte_recent_description = aap.coporte_recent_description
              _this.projet_nom = aap.projet_nom
              _this.axe = aap.axe
              _this.date_debut = aap.date_debut
              _this.date_fin = aap.date_fin
              _this.origine = aap.origine
              _this.presentation = aap.presentation
              _this.aap_tag_ids = aap.tag_ids
              _this.aap_quartier_ids = aap.quartier_ids
              _this.aap_public_ids = aap.public_ids
              _this.aap_commune_ids = aap.commune_ids

              // Projet
              //
              if (typeof(aap.projet_illustration) != 'undefined' ) {
                _this.projet_illustration = aap.projet_illustration
              }

              // Déroulement
              //
              _this.evenements_ponctuel = aap.evenements_ponctuel
              _this.activites_annuelles = aap.activites_annuelles
              _this.ateliers_activite = aap.ateliers_activite
              _this.nombre_cdi = aap.nombre_cdi
              _this.nombre_cdi_etp = aap.nombre_cdi_etp
              _this.nombre_cdd = aap.nombre_cdd
              _this.nombre_cdd_etp = aap.nombre_cdd_etp
              _this.nombre_precaire = aap.nombre_precaire
              _this.nombre_precaire_etp = aap.nombre_precaire_etp
              _this.nombre_contrat_aides = aap.nombre_contrat_aides
              _this.nombre_contrat_aides_etp = aap.nombre_contrat_aides_etp
              _this.nombre_benevoles = aap.nombre_benevoles
              _this.nombre_benevoles_etp = aap.nombre_benevoles_etp
              _this.nombre_fonctionnaires = aap.nombre_fonctionnaires
              _this.nombre_fonctionnaires_etp = aap.nombre_fonctionnaires_etp
              _this.nombre_autres = aap.nombre_autres
              _this.nombre_autres_etp = aap.nombre_autres_etp

              // Objectif
              //
              _this.projet_objectif = aap.projet_objectif


              // Résultat attendus
              _this.impact_social = aap.impact_social

              //  Quel public allez-vous toucher?
              _this.femmes_tranche_1 = aap.femmes_tranche_1
              _this.hommes_tranche_1 = aap.hommes_tranche_1
              _this.femmes_tranche_2 = aap.femmes_tranche_2
              _this.hommes_tranche_2 = aap.hommes_tranche_2
              _this.femmes_tranche_3 = aap.femmes_tranche_3
              _this.hommes_tranche_3 = aap.hommes_tranche_3
              _this.femmes_tranche_4 = aap.femmes_tranche_4
              _this.hommes_tranche_4 = aap.hommes_tranche_4
              _this.femmes_tranche_5 = aap.femmes_tranche_5
              _this.hommes_tranche_5 = aap.hommes_tranche_5
              _this.femmes_tranche_6 = aap.femmes_tranche_6
              _this.hommes_tranche_6 = aap.hommes_tranche_6

              // Budget
              _this.budget_global = aap.budget_global
              _this.charges = aap.charges
              _this.autre_financement = aap.autre_financement
              _this.subvention_sollicitee = aap.subvention_sollicitee

              // Informations complémentaires
              _this.infos_complementaires = aap.infos_complementaires
              _this.besoins_locaux = aap.besoins_locaux
              _this.besoins_materiels = aap.besoins_materiels
              _this.besoins_benevoles = aap.besoins_benevoles
              _this.besoins_expertise = aap.besoins_expertise
              _this.besoins_financement = aap.besoins_financement
              _this.benevoles = aap.benevoles
              _this.locaux = aap.locaux
              _this.materiels = aap.materiels
              _this.expertise = aap.expertise
              // _this.demande_financement = aap.demande_financement
              // _this.demande_financement_montant = aap.demande_financement_montant

              _this.coporteur = aap.coporteur
              _this.cofinancements = aap.cofinancements
              _this.cofinancements_attente = aap.cofinancements_attente
              _this.coporteur_nom = aap.coporteur_nom
              _this.coporteur_site_internet = aap.coporteur_site_internet
              _this.coporteur_co_finance = aap.coporteur_co_finance

              _this.check_budget_global()
              _this.check_subvention_sollicitee()

            })
            .catch(function (error) {
              if (error.response) {
                _this.message = error
                _this.message_type = "alert-danger"
                const status = error.response.status

                if(status === 401) {
                  window.location.replace("/");
                }
              }
            })
            .then(function () {
                  // always executed
                }
            );
      }

      [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "aap_publics.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.aap_publics = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );

    },

    set_logo_structure: function (img_url) {
      this.logo_structure = img_url
    },

    set_photo_porteur: function (img_url) {
      this.photo_porteur = img_url
    },

    set_projet_illustration: function (img_url) {
      this.projet_illustration = img_url
    },

    check_budget_global: function () {
      const _this = this
      const budget_global = parseInt(_this.budget_global, 10)

      if (isNaN(budget_global)) {
        _this.invalid_budget_global = true
        return
      }

      if (budget_global < 1250) {
        _this.invalid_budget_global = true
        return
      }

      _this.max_subvention = Math.trunc(budget_global * 80 / 100)
      _this.invalid_budget_global = false
      _this.check_subvention_sollicitee()
    },

    check_subvention_sollicitee: function () {
      const _this = this
      const subvention_sollicitee = parseInt(_this.subvention_sollicitee, 10)
      const budget_global = parseInt(_this.budget_global, 10)
      let max_subvention = 0

      if (isNaN(budget_global)) {
        this.invalid_budget_global = true
        this.invalid_subvention_solicitee = true
        return
      }

      if (isNaN(subvention_sollicitee)) {
        this.invalid_subvention_solicitee = true
        return
      }

      max_subvention = budget_global * 80 / 100

      if( subvention_sollicitee < 1000 || subvention_sollicitee > 40000 || subvention_sollicitee > max_subvention) {
        this.invalid_subvention_solicitee = true
        return
      }

      this.invalid_subvention_solicitee = false
      _this.check_budget_global()
    },

    post_structure: async function () {

      this.timer = Date.now();
      this.get_Time_Last_Save();

      const _this = this;
      let method = ""

      let [secure_key, customer_id, api_url] = await get_token_2()

      if (_this.aap_id == 0 && _this.id_aap == 0) {
        method = 'post'
        api_url += "aaps.json"
      } else {
        method = 'patch'

        api_url += `aaps/${_this.id_aap}.json`
      }

      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      // const form_data = new FormData();
      const form_element = document.getElementById("aap_form");
      const form_data = new FormData(form_element);

      form_data.append('logo_structure_base64', _this.logo_structure)
      form_data.append('photo_porteur_base64', _this.photo_porteur)
      form_data.append('projet_illustration_base64', _this.projet_illustration)

      axios({
        method: method,
        url: api_url,
        data: form_data
      })
          .then(function (response) {
            _this.message = "Candidature enregistrée, retrouvez cette candidature dans \"Mes Candidatures\"";
            _this.message_type = "alert-success";
            _this.aap = response.data.aap
            _this.id_aap = _this.aap.id
            _this.get_data()
          })
          .catch(function (error) {

            _this.errors = error;
            _this.message = "Une erreur est survenue. Contactez votre support";
            _this.message_type = "alert-danger";
          });
    },

    toggleCollapse: function (collapsed, enable=true) {
      if(enable) {
        $(collapsed).collapse('show');
      }
      else{
        $(collapsed).collapse('hide');
      }
    },

  }

}
</script>

<style scoped>

</style>